import React from "react";
import PropTypes from "prop-types";
import queryToUrl from "../../../Srp/helpers/queryToUrl";
import classes from "./styles.module.scss";

const PrevButton = ({ currentPage, onClick, query }) => (
  <a
    href={
      typeof query === "string"
        ? query
        : queryToUrl({ ...query, page: currentPage - 1 })
    }
    className={classes.PrevButton}
    data-ga={`srp_prev_page_${currentPage}`}
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  />
);

PrevButton.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  query: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default PrevButton;
